export default "__VITE_ASSET__64028df7__"